import React from 'react';
import Label from './Label';
import Container from './Container';
import TimeDisplay from './TimeDisplay';

export default ({ children }) => (
  <Container>
    <Label>Estimated pickup time:</Label>
    <TimeDisplay>{children}</TimeDisplay>
  </Container>
);
